import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import {  DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { __OBJECT_STRUCTURE_GetList } from '../../../../common/ObjectStructures/Trasnversal';
import { Card, Col, Row } from 'react-bootstrap';
import { __ActionStatus, __KPIPeriods, __MessageTypes } from '../../../../common/Dictionaries';
import { isNullOrEmpty, showMessage } from '../../../../common/Helpers';
import { __OBJECT_STRUCTURE_GetRevision } from '../../../../common/ObjectStructures/sKPI';
import { useGetBasicRevisionInformation, useGetGapRevionListPossibleActions, useGetGapRevisionPossibleGaps } from '../../../../hooks/services/sKPI/useOfGAP';
import { addGapRevision, updateGapRevision } from '../../../../services/sKPI/gap.service';
import { Calendar } from 'react-calendar';
import moment from 'moment';
import PropTypes from 'prop-types';

import MessageBox from '../../../Common/Message/MessageBox';
import CLabel from '../../../Common/CLabel';
import { Checkbox, Icon, Pivot, PivotItem, TooltipHost } from '@fluentui/react';
import CTextBox from '../../../Common/CTextBox';

const SidePanelAddRevision = (props) => {
    const { t } = useTranslation();

    const { 
        inputParam_GapAnalyzeId = null,
        inputParam_GapElementId = null,
        inputParam_GapRevisionId = null,
        inputParam_IsPanelOpen = false,
        inputParam_SetterIsPanelOpen = null,
        inputParam_EditMode = true,
        inputParam_SetRevisionList = null,
        inputParam_RevisionList = null,
    } = props;

    const [selectedPivotKey, setSelectedPivotKey] = useState('pvGapItem');



    const [actionsToAnalyzeList, setActionsToAnalyzeList] = useState(__OBJECT_STRUCTURE_GetList());
    useGetGapRevionListPossibleActions(inputParam_GapAnalyzeId, inputParam_GapElementId, inputParam_GapRevisionId, actionsToAnalyzeList.data, setActionsToAnalyzeList, inputParam_IsPanelOpen)

    const [gapToAnalyzeList, setGapToAnalyzeList] = useState(__OBJECT_STRUCTURE_GetList());
    useGetGapRevisionPossibleGaps(inputParam_GapAnalyzeId, inputParam_GapElementId, inputParam_GapRevisionId, gapToAnalyzeList.data, setGapToAnalyzeList, inputParam_IsPanelOpen)
    

    const [actionsToAnalyzeListAux, setActionsToAnalyzeListAux] = useState(null);
    const [gapToAnalyzeListAux, setGapToAnalyzeListAux] = useState(null);
    const [objRevision, setObjRevision] = useState(__OBJECT_STRUCTURE_GetRevision());
    useGetBasicRevisionInformation(inputParam_GapAnalyzeId, inputParam_GapRevisionId, objRevision, setObjRevision, inputParam_IsPanelOpen, true, setGapToAnalyzeListAux, setActionsToAnalyzeListAux)
  


    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const validateForm = (obj) => {
        const isInvalidReferenceDate = isNullOrEmpty(obj.referenceDate);

        return !isInvalidReferenceDate;
    };

    const onAddEditRevision = (e) => {
        let formIsValid = validateForm(objRevision);

        if (formIsValid === true) {
            
            if (objRevision.id === null) {
                objRevision.id = 0;
                objRevision.statusId = 1;
            }

            objRevision.title = `${t('data-lang-lbl-revision')} - ${moment(objRevision.referenceDate[0]).format('YYYYMM')}`  //[##] Debe ser el periodo segun la fecha seleccionada.
            objRevision.periodId = moment(objRevision.referenceDate[0]).format('YYYYMM')//[##] Debe ser el periodo segun la fecha seleccionada.
            objRevision.referenceDate = moment(objRevision.referenceDate[0]).toDate();
            objRevision.gapAnalyzeId = inputParam_GapAnalyzeId;            

            objRevision.l_action_ids = actionsToAnalyzeList.data.filter(x => x.checked).map(x => (x.id))

            if (objRevision.id === null || objRevision.id === 0) {
                objRevision.l_gap_ids = gapToAnalyzeList.data.filter(x => x.checked).map(x => (x.id))

                addGapRevision(objRevision).then((response) => {
                    if (response.data.succeeded) {
                        let newObjRevision = {
                            dataserieList: [],
                            gapAnalyzeId: objRevision.gapAnalyzeId,
                            id: response.data.data,
                            key: response.data.data,
                            l_element_id: [],
                            name: moment(objRevision.referenceDate).format('YYYY/MM/DD'),
                            periodId: parseInt(objRevision.periodId),
                            referenceDate: objRevision.referenceDate,
                            statusId: objRevision.statusId
                        }
    
                        inputParam_RevisionList.push(newObjRevision)
                        inputParam_SetRevisionList && inputParam_SetRevisionList(prevState => ({
                            ...prevState,
                            data: inputParam_RevisionList
                        }));
    
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
    
                    }
                }).catch((ex) => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
            else {
                if (gapToAnalyzeList.data.length > 0) {
                    objRevision.l_gap_ids = gapToAnalyzeList.data.filter(x => x.checked).length > 0 ? [...gapToAnalyzeList.data.filter(x => x.checked).map(x => (x.id)), ...gapToAnalyzeListAux.filter(x => x.checked).map(x => (x.id))] : []
                }

                updateGapRevision(objRevision.id, objRevision).then((response) => {
                    if (response.data.succeeded) {
                        let newObjRevision = {
                            dataserieList: [],
                            gapAnalyzeId: objRevision.gapAnalyzeId,
                            id: response.data.data,
                            key: response.data.data,
                            l_element_id: [],
                            name: moment(objRevision.referenceDate).format('YYYY/MM/DD'),
                            periodId: parseInt(objRevision.periodId),
                            referenceDate: objRevision.referenceDate,
                            statusId: objRevision.statusId
                        }
    
                        try {
                            inputParam_RevisionList.push(newObjRevision)
                            inputParam_SetRevisionList && inputParam_SetRevisionList(prevState => ({
                                ...prevState,
                                data: inputParam_RevisionList
                            }));
                        } catch (error) {
                            
                        }
    
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
    
                    }
                }).catch((ex) => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                });
            }
        } else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'))
        }
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
        showMessage(setMessageConfig, false, null, null)
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        <PrimaryButton className='me-1' onClick={onAddEditRevision} text={(objRevision.id === null || objRevision.id === 0)? t('data-lang-btn-add') : t('data-lang-btn-edit')} />
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    };

    const handleSelect = (value) => {
        setObjRevision(prevState => ({
            ...prevState,
            referenceDate: value
        }));
    };

    const [calendarConfig, setCalendarConfig] = useState({
        maxDetail:"month",
        minDetail:"century",
        selectRange:false,
        showDoubleView:false,
        onChange:handleSelect,
        returnValue:"range"
    });

    const onClickMonth = (value) => {
        setObjRevision(prevState => ({
            ...prevState,
            referenceDate: value
        }));
    };

    const handlePivotChange = (item) => {
        setSelectedPivotKey(item.props.itemKey);
    };

    const handleSelectionGapsChanged = (ev, isChecked, _element) => {
        const aux_list = [...gapToAnalyzeList.data]

        if (isChecked) {

                const updatedGapToAnalyzeListAux = aux_list.map(item =>
                    item.id === _element.id ? { ...item, checked: true } : item
                );
                setGapToAnalyzeList(prevState => ({
                    ...prevState,
                    data: updatedGapToAnalyzeListAux
                }));

        }
        else {

                const updatedGapToAnalyzeListAux = aux_list.map(item =>
                    item.id === _element.id ? { ...item, checked: false } : item
                );
                setGapToAnalyzeList(prevState => ({
                    ...prevState,
                    data: updatedGapToAnalyzeListAux
                })); 
            
        }
    };

    const handleSelectionActionsChanged = (ev, isChecked, _element) => {
        const aux_list = [...actionsToAnalyzeList.data]

        if (isChecked) {

                const updatedActionsToAnalyzeListAux = aux_list.map(item =>
                    item.id === _element.id ? { ...item, checked: true } : item
                );

                setActionsToAnalyzeList(prevState => ({
                    ...prevState,
                    data: updatedActionsToAnalyzeListAux
                }));
         
        }
        else {

                const updatedActionsToAnalyzeListAux = aux_list.map(item =>
                    item.id === _element.id ? { ...item, checked: false } : item
                );

                setActionsToAnalyzeList(prevState => ({
                    ...prevState,
                    data: updatedActionsToAnalyzeListAux
                }));
           
        }
    };

    const renderGapCards = (item, index) => {
        return  <Card key={index}>
                    <Card.Body>
                        <Row>
                            <Col xl={1}>
                                <Row>
                                    <Col>
                                        <Checkbox checked={item.checked} onChange={(ev, checked) => handleSelectionGapsChanged(ev, checked, item)} />
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <Col>
                                        { item.variableName })
                                    </Col>
                                    <Col xl={12}>
                                        <CLabel labelText={t('data-lang-lbl-period')} labelValue={ item.serieTimeStr } />
                                    </Col>
                                </Row>
                            </Col>
                            <Col>
                                <Row>
                                    <Col xl={12}>
                                        <CLabel labelText={t('data-lang-lbl-real')} labelValue={ item.dataserieValue } />
                                    </Col>
                                    <Col xl={12}>
                                        <CLabel labelText={t('data-lang-lbl-goal')} labelValue={ item.dataserieGoal } />
                                    </Col>
                                    
                                </Row>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
    }

    const renderActionCards = (item, index) => {
        const dateToolTipValue = item.beginDate !== null && item.endDate !== null ? 
                                `${moment(item.beginDate).format('DD/MM/YYYY')} ${t('data-lang-lbl-to')} ${moment(item.endDate).format('DD/MM/YYYY')}` :
                                (item.beginDate !== null) ? moment(item.beginDate).format('DD/MM/YYYY') : (item.endDate !== null ? moment(item.endDate).format('DD/MM/YYYY') : t('data-lang-lbl-nodata') )

        const flyItemData = __ActionStatus.find(x => x.key === item.statusId);

        return  <Card key={index}>
                    <Card.Body>
                        <Row>
                            <Col xl={1}>
                                <Checkbox checked={item.checked} disabled={item.gapActionType === "general"} onChange={(ev, checked) => handleSelectionActionsChanged(ev, checked, item)} />
                            </Col>
                            <Col>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col> { item.title } </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                {item.variableName}
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col className='col-auto mx-auto'>
                                        <TooltipHost content={ dateToolTipValue } >
                                            <Icon iconName="Calendar" className='cursor-pointer' style={{ fontSize: "14px" }} />
                                        </TooltipHost>
                                    </Col>
                                </Row>
                            </Col> 
                            <Col>
                                <Row>
                                    <Col xl={12}>
                                    {t(flyItemData.text)}
                                    </Col>
                                    <Col xl={12}>
                                    {flyItemData.executor}
                                    </Col>
                                </Row> 
                                <Row>
                                    <Col>
                                        {item.serieTimeStr}
                                    </Col>
                                </Row>
                            </Col>                          
                        </Row>
                        
                    </Card.Body>
                </Card>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ (objRevision.id === null || objRevision.id === 0)? t('data-lang-boxname-addrevision') : t('data-lang-boxname-editrevision') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row>
                    <Col className="mt-3">
                            <Calendar
                                className={"box-position-unset"}
                                onChange={onClickMonth}
                                returnValue={calendarConfig.returnValue}
                                value={objRevision.referenceDate ? objRevision.referenceDate : null}
                                selectRange={calendarConfig.selectRange}
                                showNeighboringMonth={false}
                                maxDate={new Date()}
                                minDetail={calendarConfig.minDetail}
                                maxDetail={calendarConfig.maxDetail}
                                showDoubleView={calendarConfig.showDoubleView}
                                formatLongDate={(locale, date) => moment(date).format("DD/MM/YYYY")}
                                locale={"es-ES"}
                            />
                    </Col>
                </Row>
                <Row className='pt-3'>
                    <Col>
                        <CTextBox controlValue={ !isNullOrEmpty(objRevision.title) ? objRevision.title : `${t('data-lang-lbl-revision')} - ${moment(objRevision.referenceDate !== null ? objRevision.referenceDate[0] : Date.now).format('YYYY-MM-DD')}` } setterControlValue={ null } editMode={false} textBoxName="title" labelText={ t('data-lang-lbl-name') } />
                    </Col>
                </Row>
                <Row>
                    <Col className="mt-3">
                        <Pivot selectedKey={selectedPivotKey} onLinkClick={handlePivotChange}>
                            <PivotItem headerText="Gaps to analyze" itemKey='pvGapItem'>
                                {
                                    gapToAnalyzeList.data &&
                                    gapToAnalyzeList.data.map((item, index) => (
                                        renderGapCards(item, index)
                                    ))
                                }
                            </PivotItem>
                            <PivotItem headerText="Actions to analyze" itemKey='pvActionItem'>
                                {
                                    actionsToAnalyzeList.data &&
                                    actionsToAnalyzeList.data.map((item, index) => (
                                        renderActionCards(item, index)
                                    ))
                                }
                            </PivotItem>
                        </Pivot>
                    </Col>
                </Row>
            </Panel>
        </div>
    );
};

SidePanelAddRevision.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number.isRequired,
    inputParam_GapElementId: PropTypes.number.isRequired,
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_SetRevisionList: PropTypes.func.isRequired,
    inputParam_RevisionList: PropTypes.array.isRequired,
    inputParam_GapRevisionId: PropTypes.number,
};

export default SidePanelAddRevision;